/**
 * badge-engine.js
 * ===============
 * Handles the hydration of .geo-badge and .prd-badge elements across all views.
 * Runs on DOMContentLoaded to ensure tag-maps are loaded from index.js
 * and DOM elements are present.
 *
 * Both badge types use the same pattern:
 *   - Ghost renders hidden <a> elements for ALL internal tags via the partial.
 *   - This engine filters using the slug prefix (hash-geo-* / hash-prd-*),
 *     looks up route + display name from tag-maps.js, then reveals the badge.
 *   - Unknown slugs stay hidden — no spurious output.
 */

document.addEventListener('DOMContentLoaded', function () {

    var geoRoutes = (window.PSA && window.PSA.tagMaps) ? window.PSA.tagMaps.geoRoutes : {};
    var prdRoutes = (window.PSA && window.PSA.tagMaps) ? window.PSA.tagMaps.prdRoutes : {};

    // 1. Hydrate and Reveal GEO Badges
    // Matches: hash-geo-country-* slugs. Sets country name + route, then reveals.
    document.querySelectorAll('.geo-badge').forEach(function (el) {
        var geo = geoRoutes[el.dataset.tag];
        if (!geo) return; // Slug not in map — keep hidden

        el.href = geo.route;
        el.textContent = geo.countryName;
        el.setAttribute('aria-label', 'View all ' + geo.countryName + ' content');

        // Reveal badge once hydrated (was hidden to prevent FOUC of raw Ghost tag name).
        el.classList.remove('hidden');
        el.classList.add('inline-flex', 'items-center', 'justify-center');
    });

    // 2. Hydrate and Reveal PRD Badges
    // Matches: hash-prd-* slugs. Sets display name + resolves country-scoped href.
    document.querySelectorAll('.prd-badge').forEach(function (badge) {
        var slug = badge.dataset.tag;
        var prd = prdRoutes[slug];
        if (!prd) return; // Slug not in map — keep hidden (e.g. non-PRD internal tags)

        // Set the human-readable display name from tag-maps.js
        badge.textContent = prd.name;
        badge.setAttribute('aria-label', prd.name);

        // Resolve the country-scoped href by finding the associated GEO context.
        var countryRoute = null;
        var container = badge.closest('article') || badge.closest('.flex') || document;

        // Strategy A: Sibling .geo-badge element (post.hbs view)
        var geoBadges = container.querySelectorAll('.geo-badge');
        for (var i = 0; i < geoBadges.length; i++) {
            var geo = geoRoutes[geoBadges[i].dataset.tag];
            if (geo) {
                countryRoute = geo.route;
                break;
            }
        }

        // Strategy B: data-tags attribute on the parent article (item-card.hbs view)
        if (!countryRoute && container.dataset && container.dataset.tags) {
            var match = container.dataset.tags.match(/hash-geo-country-[a-z]+/);
            if (match) {
                var geo = geoRoutes[match[0]];
                if (geo) countryRoute = geo.route;
            }
        }

        if (countryRoute) {
            badge.href = countryRoute + prd.route;
        }

        // Reveal badge — name and (where possible) href are now resolved.
        badge.classList.remove('hidden');
        badge.classList.add('inline-flex', 'items-center', 'justify-center');
    });

});
